// USING the REACT_APP_CONFIG, set the config conditionally.

const local = {
  api: {
    APP_GQL_HOST: "https://discovery-api-np.groundtruth.com/mock/",
    APP_GQL_MOCK: "https://kmx1twctkk.execute-api.us-east-1.amazonaws.com/mock/graphql",
    MOCK_INSIGHTS_GQL_HOST:
      "https://9bxuig29g3.execute-api.us-west-2.amazonaws.com/Stage/marketshare",
    INSIGHTS_GQL_HOST:
      "https://4cyjrih227.execute-api.us-east-1.amazonaws.com/np/brand-insights",
    LOGIN_URL:
      "https://login-staging.groundtruth.com/?app=lip&return_url=http://localhost.groundtruth.com:3000",
    SIGNOUT_URL:
      "https://login-staging.groundtruth.com/logout?app=lip&return_url=http://localhost.groundtruth.com:3000",
    LM_Deep_Linking_URL: "https://locations-develop.groundtruth.com/",
  },
  available_apps: {
    ADS_MANAGER_URL: "https://ads-develop.groundtruth.com",
    AUDIENCE_MANAGER_URL: "https://audience-staging.groundtruth.com",
    CONSOLE_URL: "https://console-develop.groundtruth.com",
    LOCATION_MANAGER_URL: "https://locations-develop.groundtruth.com",
  },
  mapProdConfig: false,
  sentryDSN: "",
}

const staging = {
  api: {
    APP_GQL_HOST: "https://discovery-api-np.groundtruth.com/mock/",
    APP_GQL_MOCK: "https://kmx1twctkk.execute-api.us-east-1.amazonaws.com/mock/graphql", //To be modified later
    INSIGHTS_GQL_HOST:
      "https://4cyjrih227.execute-api.us-east-1.amazonaws.com/np/brand-insights",
    LOGIN_URL:
      "https://login-staging.groundtruth.com/?app=lip&return_url=https://location-software-np.groundtruth.com/",
    SIGNOUT_URL:
      "https://login-staging.groundtruth.com/logout?app=lip&return_url=https://location-software-np.groundtruth.com/",
    LM_Deep_Linking_URL: "https://locations.groundtruth.com",
  },
  available_apps: {
    ADS_MANAGER_URL: "https://ads-develop.groundtruth.com",
    AUDIENCE_MANAGER_URL: "https://audience-staging.groundtruth.com",
    CONSOLE_URL: "https://console-staging.groundtruth.com",
    LOCATION_MANAGER_URL: "https://locations-develop.groundtruth.com",
  },
  mapProdConfig: false,
  sentryDSN: "https://c225ee08706b4134b4546c3407e18fef@apps-sentry.groundtruth.com/61",
}

const qa = {
  api: {
    APP_GQL_HOST: "https://discovery-api-np.groundtruth.com/mock/",
    LG_GQL_HOST: "https://kmx1twctkk.execute-api.us-east-1.amazonaws.com/dev/graphql",
    INSIGHTS_GQL_HOST:
      "https://4cyjrih227.execute-api.us-east-1.amazonaws.com/np/brand-insights",
    LOGIN_URL:
      "https://login-staging.groundtruth.com/?app=lip&return_url=https://location-software-qa.groundtruth.com/",
    SIGNOUT_URL:
      "https://login-staging.groundtruth.com/logout?app=lip&return_url=https://location-software-qa.groundtruth.com/",
    LM_Deep_Linking_URL: "https://locations.groundtruth.com",
  },
  available_apps: {
    ADS_MANAGER_URL: "https://ads-develop.groundtruth.com",
    AUDIENCE_MANAGER_URL: "https://audience-staging.groundtruth.com",
    CONSOLE_URL: "https://console-develop.groundtruth.com",
    LOCATION_MANAGER_URL: "https://locations-develop.groundtruth.com",
  },
  mapProdConfig: false,
  sentryDSN: "https://c225ee08706b4134b4546c3407e18fef@apps-sentry.groundtruth.com/61",
}

const prod = {
  api: {
    APP_GQL_HOST: "https://discovery-api.groundtruth.com/prod/",
    INSIGHTS_GQL_HOST:
      "https://lefdzmycej.execute-api.us-east-1.amazonaws.com/prod/brand-insights/market-share",
    LOGIN_URL:
      "https://login.groundtruth.com/?app=lip&return_url=https://discovery.groundtruth.com/",
    SIGNOUT_URL:
      "https://login.groundtruth.com/logout?app=lip&return_url=https://discovery.groundtruth.com/",
    LM_Deep_Linking_URL: "https://locations.groundtruth.com",
  },
  available_apps: {
    ADS_MANAGER_URL: "https://ads.groundtruth.com",
    AUDIENCE_MANAGER_URL: "https://audience.groundtruth.com",
    CONSOLE_URL: "https://console.groundtruth.com",
    LOCATION_MANAGER_URL: "https://locations.groundtruth.com",
  },
  mapProdConfig: true,
  sentryDSN: "https://c225ee08706b4134b4546c3407e18fef@apps-sentry.groundtruth.com/61",
}

export const config = () => {
  let platformEnv
  switch (process.env.REACT_APP_CONFIG) {
    case "prod":
      platformEnv = prod
      break
    case "staging":
      platformEnv = staging
      break
    case "qa":
      platformEnv = qa
      break
    default:
      platformEnv = local
  }

  return platformEnv
}

const defaultConfig = {
  // Add common config values here
  common: 1,
  ...config(),
}

export default defaultConfig
